// extracted by mini-css-extract-plugin
module.exports = {"widgetTypeForm":"WidgetTypeForm_widgetTypeForm__3-66I","checkboxList":"WidgetTypeForm_checkboxList__1dASn"};